import { COMPANY } from "@/lib/api";

export default function WhatsAppButton() {
  const text = encodeURIComponent(
    `Hi ${COMPANY.short} — I'd like a quote for a starter motor / alternator. Vehicle: `
  );
  const href = `https://wa.me/${COMPANY.whatsapp}?text=${text}`;
  return (
    <a
      data-testid="whatsapp-floating-button"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 left-5 z-50 group"
    >
      <div className="relative">
        <span className="absolute inset-0 bg-[#25D366] blur-md opacity-50 group-hover:opacity-80 transition" />
        <div className="relative flex items-center gap-3 bg-[#25D366] text-ink-900 px-4 py-3 border border-[#1da851] shadow-[4px_4px_0_#0A0A0A] hover:translate-x-[-2px] hover:translate-y-[-2px] hover:shadow-[6px_6px_0_#0A0A0A] transition-transform">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden>
            <path d="M20.52 3.48A11.94 11.94 0 0 0 12.01 0C5.4 0 .03 5.37.03 11.99c0 2.11.55 4.18 1.6 6L0 24l6.2-1.62a11.97 11.97 0 0 0 5.81 1.48h.01c6.62 0 12-5.37 12.01-11.99 0-3.2-1.25-6.21-3.51-8.39ZM12.02 21.3h-.01a9.3 9.3 0 0 1-4.74-1.3l-.34-.2-3.68.96.98-3.58-.22-.37a9.3 9.3 0 0 1-1.42-4.92c0-5.14 4.19-9.32 9.34-9.32 2.5 0 4.84.97 6.6 2.73a9.27 9.27 0 0 1 2.74 6.6c0 5.14-4.19 9.4-9.25 9.4Zm5.34-6.97c-.29-.15-1.74-.86-2.01-.96-.27-.1-.47-.15-.66.15-.2.29-.76.96-.93 1.16-.17.19-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.47-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.36-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.58-.49-.5-.66-.51l-.56-.01c-.2 0-.51.07-.78.36-.27.29-1.02 1-1.02 2.44 0 1.44 1.04 2.83 1.19 3.02.15.2 2.04 3.12 4.95 4.37.69.3 1.23.48 1.65.61.69.22 1.32.19 1.81.12.55-.08 1.74-.71 1.98-1.4.24-.69.24-1.27.17-1.4-.07-.13-.27-.2-.56-.34Z"/>
          </svg>
          <span className="font-mono-tech text-[10px] font-bold hidden sm:inline">WhatsApp Us</span>
        </div>
      </div>
    </a>
  );
}
